import API from "./API";

export default class PaymentKindAPI extends API {
  constructor(parameters = {}) {
    super("/PaymentName", parameters);
  }

  createPayment(data) {
    return this.submit("post", `${this.endpoint}`, data);
  }

  updatePayment(data) {
    return this.submit("put", `${this.endpoint}`, data);
  }

  getAllPaymentName() {
    return this.submit("get", `${this.endpoint}`);
  }

  getPaymentKindsAndTypes() {
    return this.submit("get", `${this.endpoint}/Kinds`);
  }
}
